<template>
  <div class="FooterMenu layout-container py-32 desk:py-64 type-xs desk:type-sm">
    <div v-if="footer.logo.filename" class="desk:layout-container pb-32">
      <nuxt-img
        preset="standard"
        loading="lazy"
        class="w-70 h-64 h-auto"
        :src="footer.logo?.filename"
        :alt="footer.logo?.alt"
      />
    </div>
    <div class="desk:flex desk:layout-container desk:justify-between">
      <div class="desk:basis-1/2 grow-0 desk:mr-24 mobOnly:pb-24 mobOnly:border-b border-light">
        <div class="type-tagline-sm desk:type-tagline text-text-subtle">
          {{ footer.footerTitle }}
        </div>
        <div class="type-headline-md wysiwyg desk:w-2/3 mt-12 desk:mt-16">
          <ExtendedWysiwyg :content="footer.footerText" />
        </div>
      </div>
      <div
        class="desk:basis-1/2 desk:flex justify-between"
      >
        <div
          class="desk:grid basis-full shrink"
          :class="`grid-cols-${navLenght}`"
        >

          <!-- contact part -->
          <div
            v-if="footer.contactHeadline && footer.contactHeadline !== '' && footer.contactTagline"
            class="mobOnly:border-b mobOnly:border-light mobOnly:py-16"
          >
            <div
              class="flex justify-between items-center"
              @click="clickMenu('', true, 'contact')"
            >
              <div class="type-tagline-sm desk:type-tagline text-text-subtle">
                {{ footer.contactTagline }}
              </div>
              <div class="cursor-pointer desk:!hidden">
                <img
                  v-if="!expanded.includes('contact')"
                  src="/icons/chevron-down-subtle.svg"
                  class="w-16 h-16"
                  alt=""
                >
                <img
                  v-else
                  src="/icons/chevron-down-subtle.svg"
                  class="w-16 h-16 rotate-180"
                  alt=""
                >
              </div>
            </div>
            <transition name="fade">
              <div
                v-if="!isMobile || expanded.includes('contact')"
                   class="pt-8 type-base desk:pr-12"
              >
                <div class="type-base-medium mt-8">{{ footer.contactHeadline }}</div>
                <div class="wysiwyg mb-12 empty:hidden">
                  <ExtendedWysiwyg
                    v-if="footer.contactAddress"
                    :content="footer.contactAddress"
                    />
                </div>
                <div
                  v-if="footer.contactPhone"
                  class="flex gap-12 mb-8"
                >
                  <img
                    src="/icons/phone.svg"
                    class="w-20"
                    alt="Phone"
                  >
                  <a :href="`tel:${footer.contactPhone}`" class="text-text-attention">
                    {{ footer.contactPhone }}
                  </a>
                </div>

                <div
                  v-if="footer.contactMail"
                  class="flex gap-12 mb-8"
                >
                  <img
                    src="/icons/mail.svg"
                    class="w-20"
                    alt="Mail"
                  >
                  <a :href="`mailto:${footer.contactMail}`" class="text-text-attention">
                    {{ footer.contactMail }}
                  </a>
                </div>

              </div>
            </transition>
          </div>

          <!-- link part -->
          <div
            v-for="link in navigation"
            :key="link._uid"
            class="mobOnly:border-b mobOnly:border-light mobOnly:py-16"
          >
            <div
              class="flex justify-between items-center"
              @click="clickMenu($sbLinkFix(link.link), (link.children.length > 0), link._uid)"
            >
              <div class="type-tagline-sm desk:type-tagline text-text-subtle">
                {{ link.title }}
              </div>
              <div v-if="link.children.length" class="cursor-pointer">
                <img
                  v-if="!expanded.includes(link._uid)"
                  src="/icons/chevron-down-subtle.svg"
                  class="w-16 h-16 desk:!hidden"
                  alt=""
                >
                <img
                  v-else
                  src="/icons/chevron-down-subtle.svg"
                  class="w-16 h-16 rotate-180 desk:!hidden"
                  alt=""
                >
              </div>
            </div>
            <transition name="fade">
              <div v-if="link.children.length && (!isMobile || expanded.includes(link._uid))" class="pt-8">
                <nuxt-link
                  v-for="child in link.children"
                  :key="child._uid"
                  class="block mt-12 first:mt-8"
                  :to="$sbLinkFix(child.link)"
                  :target="$sbLinkTarget(child.link)"
                >
                  <div class="type-headline-md hover:underline underline-offset-4 decoration-1">{{ child.title }}</div>
                </nuxt-link>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import { useUiStore } from '~/store/ui';

import { storeToRefs } from 'pinia';

const uiStore = useUiStore();

const { isMobile } = storeToRefs(uiStore);
const globalContent = useGlobalContentStore();

const navigation = globalContent.getFooterNav;
const footer = globalContent.getFooter;

const router = useRouter();
const expanded = ref<string[]>([]);
const clickMenu = (url:string, children:boolean, _uid:string) => {
  if (children) {
    if (expanded.value.includes(_uid)) {
      expanded.value = expanded.value.filter(v => v !== _uid);
    } else {
      expanded.value.push(_uid);
    }
  } else {
    const isExternal = (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'));
    if (isExternal) {
      window.location.href = url;
    } else {
      router.push({ path: url });
    }
  }
};

const navLenght = computed(()=> {
  let output = navigation.length;
  if (footer.contactHeadline && footer.contactHeadline !== '') {
    output++;
  }
  return output;
});

</script>

<style scoped lang="postcss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
